// extracted by mini-css-extract-plugin
export default {"employee-container":"CostCenter_employee-container__wgX6K"};